import logo from './images/logo.jpg'
import clothing from './images/hero.png'
import about from './images/about.png'
import moneyHeld from './images/money_held.jpg'
import model from './images/model.jpg'
import bags from './images/bags.jpg'
import blues from './images/blues.jpg'
import money from './images/money.jpg'
import lady from './images/lady.jpg'
import suit from './images/hero.jpg'
import founder from './images/founder.jpg'
import contact from './images/contact.svg'
import servicesBack from './images/services_back.png'
import history from './images/history.png'
import vision from './images/vision.png'
import mission from './images/mission.png'
import trendy from './images/trendy.png'
import casual from './images/casual.png'
import hlapo from './images/hlapo.png'
import stylishWoman from './images/stylishWoman.png'
import marketing from './images/marketing.jpeg'
import planning from './images/planning.jpeg'
import entertainment from './images/entertainment.jpeg'
import event from './images/conference.jpeg'
import style from './images/style.png'
import happy from './images/party.jpeg'
import eNews from './images/enews.jpeg'
import news from './images/onlineNews.jpeg'
import fashion from './videos/fashion.mp4'
import fashionMan from './videos/fashion_man.mp4'
import consultation from './videos/lady_sitting.mp4'

const images = {
  logo, clothing, about, money,
  model, bags, blues, moneyHeld, suit, founder,
  servicesBack, lady, contact, history, mission,
  vision, trendy, casual, style,
  stylishWoman, hlapo, marketing, planning,
  entertainment, happy, event, eNews, news
}
const videos = { fashion, fashionMan, consultation }

export { images, videos }